export default __webpack_public_path__ + "7731a0e2fa51317a3e5c949f01b42794.ply";